import axios from './axios';
import utils from '../libs/utils';

const baseUrl = 'v1/erp-business-web';

export default {
  axios,
  listSfGoodsConfigList(params) { // sfList
    return axios.post(`${baseUrl}/shunfeng/SfConfigList`, params);
  },
  updateStatus(params) { // 启用、禁用、修改id
    return axios.post(`${baseUrl}/shunfeng/submit`, params);
  },
  getExpressFee(params) { // 获取顺丰运费
    return axios.post(`${baseUrl}/shunfeng/getExpressFee`, params);
  },
  retryCreateOrder(params) { // 顺丰重下运单
    return axios.post(`${baseUrl}/shunfeng/retryCreateOrder`, utils.exchangeParams(params));
  },
};
